var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/document-text"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.4993 19.4583H7.49935C2.97435 19.4583 1.04102 17.525 1.04102 13V7.99996C1.04102 3.47496 2.97435 1.54163 7.49935 1.54163H11.666C12.0077 1.54163 12.291 1.82496 12.291 2.16663C12.291 2.50829 12.0077 2.79163 11.666 2.79163H7.49935C3.65768 2.79163 2.29102 4.15829 2.29102 7.99996V13C2.29102 16.8416 3.65768 18.2083 7.49935 18.2083H12.4993C16.341 18.2083 17.7077 16.8416 17.7077 13V8.83329C17.7077 8.49163 17.991 8.20829 18.3327 8.20829C18.6744 8.20829 18.9577 8.49163 18.9577 8.83329V13C18.9577 17.525 17.0243 19.4583 12.4993 19.4583Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.3327 9.45828H14.9993C12.1493 9.45828 11.041 8.34995 11.041 5.49995V2.16662C11.041 1.91662 11.191 1.68328 11.4243 1.59162C11.6577 1.49162 11.9243 1.54995 12.1077 1.72495L18.7743 8.39162C18.9493 8.56662 19.0077 8.84162 18.9077 9.07495C18.8077 9.30828 18.5827 9.45828 18.3327 9.45828ZM12.291 3.67495V5.49995C12.291 7.64995 12.8493 8.20828 14.9993 8.20828H16.8243L12.291 3.67495Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.834 11.9584H5.83398C5.49232 11.9584 5.20898 11.675 5.20898 11.3334C5.20898 10.9917 5.49232 10.7084 5.83398 10.7084H10.834C11.1757 10.7084 11.459 10.9917 11.459 11.3334C11.459 11.675 11.1757 11.9584 10.834 11.9584Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.16732 15.2916H5.83398C5.49232 15.2916 5.20898 15.0083 5.20898 14.6666C5.20898 14.325 5.49232 14.0416 5.83398 14.0416H9.16732C9.50898 14.0416 9.79232 14.325 9.79232 14.6666C9.79232 15.0083 9.50898 15.2916 9.16732 15.2916Z",
    fill: "#292D32"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.86d92bef25b30c9f07a087489a1dba6d.svg";
export { ForwardRef as ReactComponent };